import { useRef, useState, useCallback, useEffect } from 'react';

function getOrCreateCtx(ctxRef) {
  if (!ctxRef.current) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctxRef.current = new AC();
  }
  return ctxRef.current;
}

function scheduleNote(ctx, freq, start, dur, peak = 0.28) {
  const osc  = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(peak, start + 0.025);
  gain.gain.exponentialRampToValueAtTime(0.001, start + dur);
  osc.start(start);
  osc.stop(start + dur + 0.01);
}

export function useAlertSound() {
  const ctxRef  = useRef(null);
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    const unlock = () => {
      const ctx = getOrCreateCtx(ctxRef);
      if (ctx && ctx.state === 'suspended') ctx.resume();
    };
    window.addEventListener('click', unlock, { once: false });
    return () => window.removeEventListener('click', unlock);
  }, []);

  const playBuy = useCallback(() => {
    if (muted) return;
    const ctx = getOrCreateCtx(ctxRef);
    if (!ctx) return;
    if (ctx.state === 'suspended') { ctx.resume(); return; }
    const t = ctx.currentTime;
    scheduleNote(ctx, 523.25, t,        0.40, 0.22);
    scheduleNote(ctx, 659.25, t + 0.20, 0.40, 0.22);
    scheduleNote(ctx, 783.99, t + 0.40, 0.65, 0.28);
  }, [muted]);

  const playSell = useCallback(() => {
    if (muted) return;
    const ctx = getOrCreateCtx(ctxRef);
    if (!ctx) return;
    if (ctx.state === 'suspended') { ctx.resume(); return; }
    const t = ctx.currentTime;
    scheduleNote(ctx, 440.00, t,        0.45, 0.22);
    scheduleNote(ctx, 349.23, t + 0.22, 0.45, 0.22);
    scheduleNote(ctx, 261.63, t + 0.44, 0.70, 0.20);
  }, [muted]);

  const toggleMute = useCallback(() => {
    const ctx = getOrCreateCtx(ctxRef);
    if (ctx && ctx.state === 'suspended') ctx.resume();
    setMuted(m => !m);
  }, []);

  return { muted, toggleMute, playBuy, playSell };
}
